<template>
    <titan-form :schema="schema" v-on:saveData="saveData()" :model="dataItem"/>
</template>

<script>
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            TheHeader,
            TitanForm
        },
        mounted() {

        },
        methods: {
            saveData() {
                this.$store.dispatch('account/changePassword', this.dataItem);
            }
        },
        data() {
            return {
                dataItem: {
                    oldPassword: '',
                    newPassword: '',
                    newPasswordAgain: '',
                },
                schema: [
                    {
                        name: this.t('Change password'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Old password'),
                                model: 'oldPassword',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('New password'),
                                model: 'newPassword',
                                min: 6,
                                required: true,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('New password (again)'),
                                model: 'newPasswordAgain',
                                required: true,
                                validator: function (value, field, model) {
                                    if (model.newPassword !== model.newPasswordAgain) {
                                        return [this.t('New password fields must be equal.')];
                                    }
                                    return VueFormGenerator.validators.required(value, field, model);
                                }
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/profile/components/ChangePassword.vue